var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"wrap":""}},[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('ProductTable')],1),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('Cart')],1)],1),_c('EditProduct')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }